import React, { useState, useEffect } from 'react';

const testimonials = [
  {
    quote: "First class team. Highly knowledgeable and their customer care was exceptional. Their speed of execution was amazing and the craftsmanship was way better than any previous experiences. Always available and happy to help. I highly recommend.",
    name: "Chef Toey",
    role: "Chef"
  },
  {
    quote: "Absolutely fantastic, from initial enquiry for my restaurant project to completion. Excellent execution. Changing an old Cafe into a restaurant presented lots of problems. But Northern delivered without hesitation to overcome with nothing but solutions.",
    name: "Fatima",
    role: "Chief Accountant"
  },
  {
    quote: "I was really impressed with the service we received from Northern. They gave use a lot of guidance and support throughout the design and took care of the complete install. Thank you so much!",
    name: "Mohammed",
    role: "Secretary"
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState('next'); // To track slide direction

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setDirection('next');
      setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setDirection('prev');
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setDirection('next');
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const goToSlide = (index) => {
    setDirection(index > currentIndex ? 'next' : 'prev');
    setCurrentIndex(index);
  };

  return (
    <div className="bg-white py-16 px-4 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto text-center">
        {/* Heading and Subheading */}
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">
          TESTIMONIALS
        </h3>
        <h2 className="mtCANVAS-2 text-4xl font-bold text-indigo-900">
          What Clients Say
        </h2>
        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
          We place huge value on strong relationships and have seen the benefit they bring to our business. Customer feedback is vital in helping us to get it right.
        </p>

        {/* Carousel */}
        <div className="mt-12 relative">
          <div className="bg-indigo-900 rounded-lg h-80 sm:h-72 relative overflow-hidden">
            {/* Decorative Circles */}
            <div className="absolute top-0 right-0 h-32 w-32">
              <div className="absolute top-8 right-8 w-12 h-12 bg-indigo-200 rounded-full opacity-50"></div>
              <div className="absolute top-4 right-4 w-8 h-8 bg-indigo-200 rounded-full opacity-50"></div>
              <div className="absolute top-12 right-2 w-6 h-6 bg-indigo-200 rounded-full opacity-50"></div>
            </div>

            {/* Testimonial Content with Slide Animation */}
            <div className="absolute inset-0 flex items-center justify-center">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className={`absolute w-full max-w-3xl mx-auto text-center transition-transform duration-500 ease-in-out ${
                    index === currentIndex
                      ? 'translate-x-0 opacity-100'
                      : direction === 'next'
                      ? index < currentIndex
                        ? '-translate-x-full opacity-0'
                        : 'translate-x-full opacity-0'
                      : index > currentIndex
                      ? '-translate-x-full opacity-0'
                      : 'translate-x-full opacity-0'
                  }`}
                >
                  <p className="text-lg sm:text-xl text-gray-300 leading-relaxed px-6 sm:px-12">
                    "{testimonial.quote}"
                  </p>
                  <h4 className="mt-6 text-xl font-semibold text-orange-400">
                    {testimonial.name}
                  </h4>
                  {/* <p className="text-sm text-gray-400">
                    {testimonial.role}
                  </p> */}
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>

          {/* Pagination Dots */}
          <div className="flex justify-center mt-6 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full ${
                  currentIndex === index ? 'bg-gray-800' : 'bg-gray-400'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}